import React from "react";
import cx from "clsx";
import PropTypes from "prop-types";
import { UsersIcon } from "../../../../assets/Icons/UsersIcon";
import "./CalendarEvent.styles.scss";
import styles from "./CalendarEvent.module.scss";
import GFEIconV2 from "../../../../assets/Icons/GFEIconV2";

function CalendarEvent({
  event: { confirmed_status, isAdditionalProvider, gfeColor, isPendingPayment },
}) {
  const showGfeIcon = () => {
    return gfeColor !== null && gfeColor !== undefined;
  };

  return (
    <div className={cx("appointmentConfirmIconWrapper", styles.iconsWrapper)}>
      {/*
       * The slot is held but the patient has not paid the text2pay link yet. It sits on
       * the calendar next to confirmed bookings, so it needs a mark of its own — the
       * only other cue is the event colour, which already means invoice status.
       */}
      {isPendingPayment && (
        <span
          className={styles.pendingPaymentIcon}
          title="Awaiting payment — open the appointment to copy or resend the payment link"
        >
          <i className="fa fa-clock" />
        </span>
      )}
      {confirmed_status === "Confirmed" && (
        <span className="confirmedIcon">
          <i className="fa fa-check-circle" />
        </span>
      )}
      {showGfeIcon() && (
        <div className={styles.gfeWrapper}>
          <GFEIconV2 width="26px" height="16px" color={gfeColor} />
        </div>
      )}
      {isAdditionalProvider && (
        <div className="usersIcon">
          <UsersIcon />
        </div>
      )}
    </div>
  );
}

CalendarEvent.propTypes = {
  confirmed_status: PropTypes.string,
  isAdditionalProvider: PropTypes.bool,
  gfeColor: PropTypes.string,
  isPendingPayment: PropTypes.bool,
};

CalendarEvent.defaultProps = {
  confirmed_status: "Not Confirmed",
  isAdditionalProvider: false,
  gfeColor: null,
  isPendingPayment: false,
};

export default CalendarEvent;
